import { render, staticRenderFns } from "./BeneficiaryBoxRaise.vue?vue&type=template&id=2889db86&scoped=true&"
import script from "./BeneficiaryBoxRaise.vue?vue&type=script&lang=js&"
export * from "./BeneficiaryBoxRaise.vue?vue&type=script&lang=js&"
import style0 from "./BeneficiaryBoxRaise.vue?vue&type=style&index=0&id=2889db86&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2889db86",
  null
  
)

export default component.exports